import ApiService from "../../ApiService";

const NewListService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/newlist/loadscreenview", { }, successCallback, failureCallback);
    },
    loadMore: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/homework/newlist/loadmore", vo, successCallback, failureCallback);
    }
};

export default NewListService;